export const FETCH_DATA_EVENT_NAME = 'fetchData';
export const FETCH_DATA_EVENT_PROP_NAME = 'fetchDataEvent';
export const FetchDataEventProp = {
    type: String,
    default: 'fetch-data',
    label: 'Событие для обновления'
};
